import { render, staticRenderFns } from "./DealersView.vue?vue&type=template&id=d69bcd14"
import script from "./DealersView.vue?vue&type=script&lang=js"
export * from "./DealersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports